export default "__VITE_ASSET__BpIb0Rlg__"